import { lazy } from 'react';

export const EventListPage = lazy(() => import('./controller.js'));
